import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import TagsActions from 'app/actions/TagsActions';
import { selectTagSummariesByBib } from 'app/selectors/ugc/TagsSelector';
import AllCommunityTags from './AllCommunityTags';

export class AllCommunityTagsContainer extends React.PureComponent {
  componentDidMount() {
    const { tagsActions, metadataId } = this.props;
    tagsActions.fetchTagSummaries(metadataId);
  }

  render() {
    return <AllCommunityTags {...this.props} />;
  }
}

AllCommunityTagsContainer.propTypes = {
  metadataId: PropTypes.string.isRequired,
  tags: ImmutablePropTypes.list.isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  tags: selectTagSummariesByBib(state)
});

const mapDispatchToProps = dispatch => ({
  tagsActions: bindActionCreators(TagsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AllCommunityTagsContainer);
